import { PlatformAudit } from '@core/enums';
import { Auditoria, AuditoriaForm, AuditoriaUpsert } from '@models/.';

export function transformToData(audit: Auditoria | null): Auditoria | null {
  if (!audit) return null;
  
  return {
    ...audit,
  };
}

export function transformToForm(audit: Auditoria): AuditoriaForm {
  const {
    id: id,
    plataforma: platform,
    tipo: type,
    esFrontEnd: isFrontEnd,
    registro: record,
    nombreCargo: positionName,
    extra,
    localId: storeId,
    empleadoId: employeeId,
    estacionId: stationId,
  } = audit;
  
  return {
    id,
    platform: platform as PlatformAudit,
    type,
    isFrontEnd,
    record,
    extra,
    positionName,
    storeId,
    employeeId,
    stationId,
  };
}

export function transformToUpsert(auditForm: AuditoriaForm): AuditoriaUpsert | undefined {
  if (!auditForm) return;
  
  const {
    platform: plataforma,
    type: tipo,
    isFrontEnd: esFrontEnd,
    record: registro,
    extra,
    positionName: nombreCargo,
    storeId: localId,
    accountId: accountId,
    employeeId: empleadoId,
    stationId: estacionId,
  } = auditForm;
  
  return {
    plataforma,
    tipo,
    esFrontEnd,
    registro,
    nombreCargo,
    extra,
    localId,
    accountId,
    empleadoId,
    estacionId,
  };
}